module.exports = __webpack_public_path__ + "static/img/1097.bb8c9eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1097.jpg
// module id = 279
// module chunks = 0